import { useSnapshot } from 'valtio'
import { type ReactElement } from 'react'
import UnderlineLabelSection from '../../../../../shared/components/ui/headings/UnderlineLabelSection'
import RecurringConfigurationCustomerSection from '../CustomerSection/RecurringConfigurationCustomerSection'
import { RecurringConfigurationCreditCardDropDown } from '../CreditCardDropdown/RecurringConfigurationCreditCardDropDown'
import { recurringPaymentNewProxy } from '../recurringPaymentNewProxy'
import TooltipIcon from '../../../../../shared/components/ui/tooltips/tooltipIcon/TooltipIcon'
import PaymentFrequencySection from './PaymentFrequencySection'
import { RecurringBaseSection } from './RecurringBaseSection'
import RecurringAddressOverride from './RecurringAddressOverride'

export function PaymentConfigurationDetails (): ReactElement {
  const { customer } = useSnapshot(recurringPaymentNewProxy)

  const tooltipText = 'The selected start date will be the first occurrence of the recurring charge ' +
      'and then it will repeat based on the frequency. For example, if you want a monthly charge on the first ' +
      'of every month, select the start date as the first of the next month and set monthly as the frequency'

  return (
    <div style={{ width: '64%' }} className="bg-white shadow rounded mb-32 p-6">
      <UnderlineLabelSection labelText="Payment Details" />
      <RecurringBaseSection />
      <UnderlineLabelSection labelText="Customer Details" />
      <RecurringConfigurationCustomerSection />
      {customer && (
        <>
          <RecurringAddressOverride />
          <UnderlineLabelSection labelText="Payment Frequency">
            <TooltipIcon tooltipText={tooltipText} />
          </UnderlineLabelSection>
          <PaymentFrequencySection />
          <UnderlineLabelSection labelText="Payment Configuration Method" />
          <RecurringConfigurationCreditCardDropDown />
          {/*<AchDropDown />*/}
          {/*<AchAddModal />*/}
        </>
      )}
    </div>
  )
}
